import Listing from '@cont/Combat/Listing/Landing';
import Header from '../Common/Header';

const CombatListingLanding = ({ customPageDetails }) => (
  <>
    <Header
      label={customPageDetails?.combatsBlockTitle ?? 'Combats'}
      description={customPageDetails?.combatsBlockDescription}
    />
    <Listing />
  </>
);

export default CombatListingLanding;
